import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar, MatTableDataSource } from '@angular/material';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LunexService } from '@root/modules/lunex/services/lunex.service';
import { Location } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'edex-samerchant-trxns',
  templateUrl: './samerchant-trxns.component.html',
  styleUrls: ['./samerchant-trxns.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SamerchantTrxnsComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  addfrom:FormGroup;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  fromDate:any =''
  toDate:any = '';
  dataSource = new MatTableDataSource<any>();;
  time:any
  displayedColumns = ['orderId','merchantId', 'transactionAmount', 'transactionId', 'createdAt']
  columnsToDisplayWithExpand = [...this.displayedColumns,'customer','paymentProcessorType','expand'];
  products:any[] =[];
  user_id:any = '';
  type: string;
  constructor(
    private adminApis: LunexService,
    private _snackBar: MatSnackBar,
    private _fb:FormBuilder,
    private activatedRoute: ActivatedRoute,
    public location: Location
  ) { 
    this.activatedRoute.params.subscribe(res => {
      console.log(res);
      
      if(res && res.id) {
        this.user_id = res.id;
        if(this.user_id){
        this.getdata();
        }
      }
    })
  }

  ngOnInit() {
  }

  // getProducts() {
  //   this.adminApis.getProducts(this.type='GIFT_CARD').subscribe(
  //     res => {
  //       if(!res.error) {
  //         this.products = res.body;
  //         if(!this.adminApis.allProducts.length) {
  //           this.adminApis.allProducts = this.products;
  //         }
  //         this.getdata();
  //       }
  //     }, error => {
  //     }
  //   )
  // }

  getdata(){
    // let data= JSON.parse(JSON.stringify(this.addfrom.value));
    // data.To_Date = new Date(data.To_Date);
    // data.To_Date.setDate(data.To_Date.getDate() + 1);
    // data.seller = this.user_id;
    // if((data.From_Date && !data.To_Date) || (!data.From_Date && data.To_Date)) {
    //   this._snackBar.open('Please fill both dates', '', {duration: 2000});
    // }
    let body = {
      "user_id":this.user_id
    }
    this.adminApis.getSAmerchantsTransactions(body).subscribe(res=>{
      if(res && !res.error) {
        let data =res.result.map(item => {
          item.stripeResponse = (item.stripeResponse) ? JSON.parse(item.stripeResponse) : null;
          return item;
        })
        this.dataSource = new MatTableDataSource<any>(data);
        // this.dataSource = data || []
        this.dataSource.paginator = this.paginator;
        this.dataSource.paginator.pageIndex=0
        console.log(this.dataSource,'jebfurb');
        
      } else {
        this._snackBar.open(res.msg, '',  { duration: 2000 });
      }
    }, error => {
      this._snackBar.open('Oops! something went wrong, please try again later.', '', { duration: 2000 });
    })
  }



get f(){
  return this.addfrom.controls;
}

  searchByDate() {
    this.getdata();
  }

}

